export const PAYMENT_BALANCE_MODE = {
  COD_ONLY: 'cod_only',
  WE_OWE_CARRIER: 'we_owe_carrier',
  CARRIER_OWES_US: 'carrier_owes_us',
  NONE: 'none',
} as const

export type PaymentBalanceMode =
  (typeof PAYMENT_BALANCE_MODE)[keyof typeof PAYMENT_BALANCE_MODE]

const EPSILON = 0.005

function parseAmount(value: number | string | null | undefined): number {
  if (value == null || value === '') return 0
  const cleaned =
    typeof value === 'number' ? value : Number(String(value).replace(/,/g, ''))
  return Number.isFinite(cleaned) ? cleaned : 0
}

export interface PaymentFormulaInput {
  totalTariff: number | string | null | undefined
  deposit: number | string | null | undefined
  carrierPay: number | string | null | undefined
}

export interface PaymentFormulaResult {
  dueOnDelivery: number
  balance: number
  balanceAbsolute: number
  mode: PaymentBalanceMode
  hasCod: boolean
  hasBalance: boolean
}

export function computePaymentFormula(
  input: PaymentFormulaInput,
): PaymentFormulaResult {
  const tariff = parseAmount(input.totalTariff)
  const deposit = parseAmount(input.deposit)
  const carrierPay = parseAmount(input.carrierPay)
  const dueOnDelivery = Math.max(0, tariff - deposit)
  const balance = dueOnDelivery - carrierPay
  const hasCod = dueOnDelivery > EPSILON
  const hasBalance = Math.abs(balance) > EPSILON
  let mode: PaymentBalanceMode = PAYMENT_BALANCE_MODE.NONE
  if (hasCod && !hasBalance) mode = PAYMENT_BALANCE_MODE.COD_ONLY
  else if (!hasCod && hasBalance) mode = PAYMENT_BALANCE_MODE.WE_OWE_CARRIER
  else if (hasCod && hasBalance) {
    mode =
      balance > 0
        ? PAYMENT_BALANCE_MODE.CARRIER_OWES_US
        : PAYMENT_BALANCE_MODE.WE_OWE_CARRIER
  }
  return {
    dueOnDelivery,
    balance,
    balanceAbsolute: Math.abs(balance),
    mode,
    hasCod,
    hasBalance,
  }
}
